import React from 'react';
import { ArrowLeft, Minus, Plus, ShoppingBag, Trash2 } from 'lucide-react';
import RestaurantOverlay from './RestaurantOverlay';
import { calculateSubtotal, cartCount, formatMoney } from './restaurantUtils';

export default function RestaurantCart({
  restaurant,
  cart,
  onClose,
  onQuantity,
  onEdit,
  onCheckout
}) {
  const subtotal = calculateSubtotal(cart);
  return (
    <RestaurantOverlay title="Tu carrito" onClose={onClose} className="rc-drawer">
      <header className="rc-drawer__heading">
        <button type="button" className="rc-mobile-back" onClick={onClose}><ArrowLeft aria-hidden="true" />Volver</button>
        <span className="rc-modal-heading__icon"><ShoppingBag aria-hidden="true" /></span>
        <div><span className="rc-eyebrow">TU PEDIDO</span><h2>Tu carrito</h2><p>{restaurant?.name}</p></div>
      </header>
      <div className="rc-drawer__content">
        {!cart.length ? (
          <div className="rc-cart-empty"><ShoppingBag aria-hidden="true" /><h3>Tu carrito está vacío</h3><p>Agrega productos del menú para continuar.</p></div>
        ) : (
          <div className="rc-cart-list">
            {cart.map((item) => (
              <article className="rc-cart-item" key={item.line_id}>
                {item.image_url && <img src={item.image_url} alt="" />}
                <div className="rc-cart-item__copy">
                  <strong>{item.name}</strong>
                  {item.observation && <p>{item.observation}</p>}
                  <button type="button" onClick={() => onEdit(item)}>Editar</button>
                </div>
                <div className="rc-cart-item__price">
                  <strong>{formatMoney(item.price * item.quantity)}</strong>
                  <div className="rc-quantity">
                    <button type="button" onClick={() => onQuantity(item.line_id, -1)} aria-label={`Quitar uno de ${item.name}`}>
                      {item.quantity === 1 ? <Trash2 aria-hidden="true" /> : <Minus aria-hidden="true" />}
                    </button>
                    <span>{item.quantity}</span>
                    <button type="button" onClick={() => onQuantity(item.line_id, 1)} aria-label={`Agregar uno de ${item.name}`}><Plus aria-hidden="true" /></button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
      <footer className="rc-drawer__footer">
        <div className="rc-summary-row"><span>Subtotal ({cartCount(cart)} productos)</span><strong>{formatMoney(subtotal)}</strong></div>
        <div className="rc-summary-row rc-summary-row--muted"><span>Envío</span><span>Lo calcula PROVI al confirmar</span></div>
        <button type="button" className="rc-button rc-button--primary" disabled={!cart.length} onClick={onCheckout}>
          Continuar · {formatMoney(subtotal)}
        </button>
      </footer>
    </RestaurantOverlay>
  );
}
